module.exports = __webpack_public_path__ + "static/media/logo_1x2-gaming.01dc6d3f.svg";